export default __webpack_public_path__ + "static/media/epita.f88f36c3.png";